import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";


function RemarkDialog(props) {
    const [remark, setRemark] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        setRemark('')
    }, [props.show])

    const saveBtnHandler = () => {
        if (remark == '') {
            setError(true);
        } else {
            setError(false);
            const obj = {};
            obj.remark = remark;
            props.action(obj);
        }
    }

    return (
        <div>
            <Modal show={props.show} onHide={() => props.hide()} animation={false} centered>
                <Modal.Header closeButton>
                    {/* <Modal.Title>Enter Date:</Modal.Title> */}
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col className='col-md-10 col-6'>
                            <Form.Group>
                                <Form.Label>Payment Remark</Form.Label>
                                <Form.Control type="text" maxLength={255} placeholder='Payment Remark'
                                    value={remark} onChange={e => setRemark(e.target.value)} />
                            </Form.Group>
                        </Col>

                    </Row>
                    {
                        error &&
                        <Row>
                            <Col style={{ color: 'red' }}>Remark Can not be EMPTY.</Col>
                        </Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => saveBtnHandler()}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default RemarkDialog;